import { render, staticRenderFns } from "./BuildingEditOrdersTab.vue?vue&type=template&id=2d7fba86"
import script from "./BuildingEditOrdersTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditOrdersTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports